const attachmentAnchorPrefix = 'https://forecast.invalid/rug-addendum/'

export type AddendumAttachmentAnchor = {
  attachmentId: string
  sourcePageIndex: number
}

export function addendumAttachmentAnchorUri(
  attachmentId: string,
  sourcePageIndex: number
): string {
  if (
    attachmentId.length === 0 ||
    !Number.isSafeInteger(sourcePageIndex) ||
    sourcePageIndex < 0
  ) {
    throw new Error('Invalid addendum attachment anchor')
  }
  return `${attachmentAnchorPrefix}${encodeURIComponent(attachmentId)}/${sourcePageIndex}`
}

export function parseAddendumAttachmentAnchorUri(
  uri: string
): AddendumAttachmentAnchor | undefined {
  if (!uri.startsWith(attachmentAnchorPrefix)) return undefined
  const match = /^([^/]+)\/(0|[1-9]\d*)$/.exec(
    uri.slice(attachmentAnchorPrefix.length)
  )
  if (!match) throw new Error('Invalid addendum attachment anchor')
  const attachmentId = decodeURIComponent(match[1])
  const sourcePageIndex = Number(match[2])
  if (attachmentId.length === 0 || !Number.isSafeInteger(sourcePageIndex)) {
    throw new Error('Invalid addendum attachment anchor')
  }
  return { attachmentId, sourcePageIndex }
}
